module.exports = __webpack_public_path__ + "static/img/hw1.09ab6d47.png";